import { Component, inject, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'details-action-buttons',
  standalone: true,
  imports: [
    IonicModule
  ],
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss',
})

export class IframeComponent {
    @Input("title") title;
    @Input("url") url;

    private modalController = inject(ModalController);
    private sanitizer = inject(DomSanitizer);
    public iframeSrc: any;

    ngOnInit(){
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

    dismissModal(){
        this.modalController.dismiss().catch(e => {
            console.warn("No modal found on dismiss")
        });
    }

}